import { useAtomValue } from 'jotai';
import { WifiOff } from 'lucide-react';

import { cn } from '@crossnokaye/ux-common';

import { anyCircuitBreakerTrippedAtom } from '@/state/stream-status.state';

/**
 * A thin warning banner that appears when WebSocket stream connections are lost or unstable.
 *
 * Behavior:
 * - Appears when stream reconnection has stopped (circuit breaker tripped)
 * - Shows a single message for all stream types
 * - Auto-dismisses when reconnecting resumes and/or streams recover
 */
export const StreamStatusBanner = () => {
  const anyCircuitBreakerTripped = useAtomValue(anyCircuitBreakerTrippedAtom);

  if (!anyCircuitBreakerTripped) {
    return null;
  }

  return (
    <div
      data-component="StreamStatusBanner"
      data-testid="stream-status-banner"
      role="alert"
      aria-live="polite"
      className={cn(
        'w-full h-8 px-4 flex items-center justify-center gap-3',
        'bg-warning text-warning-foreground',
        'text-sm font-medium',
        'transition-all duration-300 ease-in-out'
      )}
    >
      <WifiOff className="size-4 flex-shrink-0" aria-hidden="true" />

      <span className="truncate">
        Browser lost data connection. Values displayed may become stale.
      </span>
    </div>
  );
};
